<mat-accordion [multi]="false" class="custom-accordion">
  <mat-expansion-panel
    *ngFor="let item of accordionItems; trackBy: trackByFn"
    class="custom-panel"
    [ngClass]="{ 'selected-panel': item.id === selectedId }"
    [expanded]="item.expanded"
    [disabled]="item.disabled"
    (opened)="onPanelOpened(item)"
    (closed)="onPanelClosed(item)"
  >
    <mat-expansion-panel-header class="panel-header">
      <div class="header-content">
        <span class="panel-title">{{ item.title }}</span>
      </div>
      <div class="header-actions">
        <button
          mat-icon-button
          class="action-btn"
          [matMenuTriggerFor]="actionMenu"
          [matTooltip]="item.actionTooltip || 'Actions'"
          (click)="$event.stopPropagation()"
        >
          <i
            [class]="'action-icon ' + (item.actionIcon || 'fas fa-ellipsis-v')"
          ></i>
        </button>
        <mat-menu #actionMenu="matMenu" class="action-menu">
          <button
            mat-menu-item
            (click)="onMenuAction('addAccordion', item, $event)"
          >
            <i class="fas fa-plus menu-icon"></i> <span>Add Accordion</span>
          </button>
          <button
            mat-menu-item
            (click)="onMenuAction('uploadFile', item, $event)"
          >
            <i class="fas fa-upload menu-icon"></i> <span>Upload File</span>
          </button>
          <button mat-menu-item (click)="onMenuAction('link', item, $event)">
            <i class="fas fa-upload menu-icon"></i> <span>Add Link</span>
          </button>
          <button mat-menu-item (click)="onMenuAction('edit', item, $event)">
            <i class="fas fa-edit menu-icon"></i> <span>Edit</span>
          </button>
          <button mat-menu-item (click)="onMenuAction('delete', item, $event)">
            <i class="fas fa-trash menu-icon"></i> <span>Delete</span>
          </button>
          <!-- Custom actions -->
          <ng-container *ngIf="item.menuActions">
            <mat-divider></mat-divider>
            <button
              *ngFor="let menuAction of item.menuActions"
              mat-menu-item
              (click)="onMenuAction(menuAction.action, item, $event)"
              [disabled]="menuAction.disabled"
            >
              <i [class]="'menu-icon ' + menuAction.icon"></i>
              <span>{{ menuAction.label }}</span>
            </button>
          </ng-container>
        </mat-menu>
      </div>
    </mat-expansion-panel-header>

    <!-- Show links if present -->
    <ng-container *ngIf="item.links && item.links.length > 0">
      <div class="links-section">
        <div
          *ngFor="let link of item.links; trackBy: trackLinkByFn"
          class="link-item py-3 px-2 d-flex align-items-center mb-2"
          [class.disabled]="link.disabled"
        >
          <!-- The link itself -->
          <a
            [href]="link.url"
            target="_blank"
            rel="noopener noreferrer"
            class="flex-grow-1 d-flex align-items-center text-decoration-none"
            (click)="onLinkClick($event, link)"
          >
            <i *ngIf="link.icon" [class]="'link-icon ' + link.icon"></i>
            <span
              class="link-label ms-2"
              [matTooltip]="link.url"
              matTooltipPosition="above"
            >
              {{ link.url }}
            </span>
          </a>

          <!-- The more icon (separate from link) -->
          <button
            mat-icon-button
            class="action-btn ms-2"
            [matMenuTriggerFor]="linkMenu"
            [matTooltip]="'Actions'"
            (click)="$event.stopPropagation(); $event.preventDefault()"
          >
            <i class="fas fa-ellipsis-v"></i>
          </button>

          <!-- The menu for links -->
          <mat-menu #linkMenu="matMenu">
            <button mat-menu-item (click)="onLinkMenuAction('view', link)">
              <i class="fas fa-eye menu-icon"></i>
              <span>View</span>
            </button>

            <button mat-menu-item (click)="onLinkMenuAction('delete', link)">
              <i class="fas fa-trash menu-icon"></i>
              <span>Delete</span>
            </button>
          </mat-menu>
        </div>
      </div>
    </ng-container>

    <!-- Nested Accordion -->
    <ng-container *ngIf="item.children && item.children.length > 0">
      <app-expansion-panel
        [items]="item.children"
        [nestedLevel]="nestedLevel + 1"
        [selectedId]="selectedId"
        (itemExpanded)="itemExpanded.emit($event)"
        (itemCollapsed)="itemCollapsed.emit($event)"
        (linkClicked)="linkClicked.emit($event)"
        (actionClicked)="actionClicked.emit($event)"
      ></app-expansion-panel>
    </ng-container>
  </mat-expansion-panel>
</mat-accordion>
